var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenfull-container",on:{"click":_vm.click}},[_c('jee-icon',{attrs:{"iconClass":"diannao"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }